import { API_AUTH } from "../../common";
const ConfigSystemApi = {
  getCauHinhTinhLai: () => API_AUTH.get("api/configsystem/getcauhinhtinhlai"),
  updateCauHinhTinhLai: (data) => API_AUTH.put("api/configsystem/updatecauhinhtinhlai", data),
  getCauHinhNhanVay: () => API_AUTH.get("api/configsystem/getcauhinhnhanvay"),
  getCauHinhHeThong: () => API_AUTH.get("api/configsystem/getcauhinhhethong"),
  updateCauHinhHeThong: (data) => API_AUTH.put("api/configsystem/updatecauhinhhethong", data),
  GetConfigSystemByKeyConfig: ({key})=>API_AUTH.get(`api/configsystem/GetConfigSystemByKeyValue?key=${key}`),
};

export default ConfigSystemApi;